import React from 'react';
import styled from 'styled-components';

import AmenityCard from 'components/ui/ActivityCard/AmenityCard';

import { getCurrentLocale } from 'helpers/i18n';
import {
  toFriendlyDateTimeString,
  toFriendlySameDateTimeRange,
  toFriendlyDateTimeRange,
} from 'helpers/Formatter';
import { isSameDay } from 'helpers/DateHelper';

const StyledAmenityCard = styled.div`
  margin-bottom: 24px;
`;

const AmenityCardList = ({ amenityBookings }) => {
  return amenityBookings.map(amenityBooking => {
    let bookingDate = toFriendlyDateTimeRange(
      amenityBooking.actionable_date,
      amenityBooking.actionable_end_date,
      { language: getCurrentLocale() }
    );
    if (isSameDay(amenityBooking.actionable_date, amenityBooking.actionable_end_date)) {
      bookingDate = toFriendlySameDateTimeRange(
        amenityBooking.actionable_date,
        amenityBooking.actionable_end_date,
        { language: getCurrentLocale() }
      );
    }
    return (
      <StyledAmenityCard>
        <AmenityCard
          title={amenityBooking.name}
          propertyName={amenityBooking.tenant_details.property}
          modifiedDate={toFriendlyDateTimeString(amenityBooking.last_updated_at_unformatted, {
            language: getCurrentLocale(),
          })}
          bookingDate={bookingDate}
          internalNotes={amenityBooking.internal_note}
          isCancelled={amenityBooking.status === 'cancelled'}
        />
      </StyledAmenityCard>
    );
  });
};

export default AmenityCardList;
